import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/yoursoftwaresupplier.webp';
import screenshot_target from '../../../images/letterfunnel/renaldomelkert.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Renaldo Melkert"
      firstname="Renaldo"
      companyname="Your Software Supplier"
      competition="Clutch en Goodfirms"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/renaldomelkert.js